var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{ref:"select",staticClass:"selectpicker",attrs:{"data-style":"btn-white"}},_vm._l((_vm.items),function(item){return _c('option',{key:item[_vm.valuefield],domProps:{"value":item.id}},[_vm._v(_vm._s(item[_vm.labelfield]))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }